export const SIDEBAR_WIDTH = 248;
export const SIDEBAR_WIDTH_COLLAPSED = 64;

/** A row is the sidebar width minus 8px each side; at 64px that leaves 48. */
const COLLAPSED_ROW_WIDTH = SIDEBAR_WIDTH_COLLAPSED - 16;

/** Horizontal padding that centres an icon of `size` in a collapsed row, so it
 *  stays in the same spot when the sidebar expands. */
export function rowPaddingFor(size: number): string {
  return `${(COLLAPSED_ROW_WIDTH - size) / 2}px`;
}

export const NAV_ICON_SIZE = 18;

const SELECTED_BG = "rgba(var(--mui-palette-primary-mainChannel) / 0.1)";
const SELECTED_BG_HOVER = "rgba(var(--mui-palette-primary-mainChannel) / 0.15)";

const rowStateSx = {
  "&:hover": { bgcolor: "action.hover" },
  "&.Mui-selected": {
    bgcolor: SELECTED_BG,
    color: "primary.main",
    "& .MuiListItemIcon-root": { color: "primary.main" },
    "& .MuiListItemText-primary": { fontWeight: 600 },
    "&:hover": { bgcolor: SELECTED_BG_HOVER },
  },
  "&.Mui-focusVisible": {
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: -2,
  },
};

/** Rows in the drawer itself. */
export const sidebarSx = {
  "& .MuiListItemButton-root": {
    mx: 1,
    mb: "2px",
    // Rows tune these through variables: a nested rule here outranks their own sx.
    pl: `var(--row-pl, var(--row-px, ${rowPaddingFor(NAV_ICON_SIZE)}))`,
    pr: `var(--row-px, ${rowPaddingFor(NAV_ICON_SIZE)})`,
    py: "var(--row-py, 4px)",
    minHeight: "var(--row-min-height, 34px)",
    gap: 1.5,
    borderRadius: 1.5,
    ...rowStateSx,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    justifyContent: "center",
    color: "text.secondary",
    "& > svg": { fontSize: NAV_ICON_SIZE },
  },
  "& .MuiListItemText-root": { my: 0, minWidth: 0 },
  "& .MuiListItemText-primary": {
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiListSubheader-root": { px: 2.5 },
};

/** Rows in a section's own sub-navigation (the column next to the sidebar). */
export const sectionNavListSx = {
  py: 0.5,
  "& .MuiListItemButton-root": {
    mx: 1,
    mb: "2px",
    px: 1.25,
    py: 0.5,
    minHeight: 32,
    gap: 1.25,
    borderRadius: 1.5,
    ...rowStateSx,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    justifyContent: "center",
    color: "text.secondary",
    "& > svg": { fontSize: 16 },
  },
  "& .MuiListItemText-root": { my: 0, minWidth: 0 },
  "& .MuiListItemText-primary": {
    fontSize: "0.8125rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiListSubheader-root": { px: 2.25, mt: 1 },
};
